import React, { useMemo } from 'react';
import { GoogleMap, useLoadScript, MarkerF } from '@react-google-maps/api';

export const libraries = ['places'];
const mapContainerStyle = {
    width: '100%',
    height: '100%',
};

// const defaultCenter = {
//     lat: 24.860966, // default latitude
//     lng: 66.990501, // default longitude
// };

// NEW YORK DEFAULT CENTER
const defaultCenter = {
    lat: 40.73061, // default latitude
    lng: -73.935242, // default longitude
};

const GoogleMapComp = ({ pointerPosition, mapClickHandler, center: customCenter, zoom, onPointerClick }) => {
    const center = useMemo(() => {
        if (customCenter) return customCenter;
        if (pointerPosition && pointerPosition.length > 0) {
            const first = pointerPosition[0];
            const lat = Number(first?.lat);
            const lng = Number(first?.lng);
            if (!isNaN(lat) && !isNaN(lng)) {
                return { lat, lng };
            }
        }
        return defaultCenter;
    }, [customCenter, pointerPosition]);

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
        libraries,
    });

    if (loadError) {
        return <div>Error loading maps</div>;
    }

    if (!isLoaded) {
        return <div>Loading maps</div>;
    }

    return (
        <>
            <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={zoom || 10}
                center={center}
                onClick={mapClickHandler}
            >
                {pointerPosition &&
                    pointerPosition?.map((pos, index) => {
                        const lat = Number(pos?.lat);
                        const lng = Number(pos?.lng);
                        if (!isNaN(lat) && !isNaN(lng)) {
                            return (
                                <MarkerF 
                                    key={index} 
                                    position={{ lat, lng }} 
                                    icon={pos.icon} 
                                    onClick={() => onPointerClick && onPointerClick(pos)}
                                />
                            );
                        }
                        return null;
                    })}
            </GoogleMap>
        </>
    );
};

export default GoogleMapComp;
